import React from "react";
import { useRouteMatch } from "react-router-dom";
import { Col, Row, Container} from "reactstrap";

import "./index.css";
import TransformationEdit from '../../components/TransformationEdit';

export default function TransformationEditPage(props: any) {
  const match = useRouteMatch("/transformation/:transformation_id");
  const params: any = match?.params;
  const transformationId = params?.transformation_id;

  const _onTransformationSaved = (returnedTransformationId:any) => {
    console.log('_onTransformationSaved');
    window.location.href = `/transformation/${returnedTransformationId}`;
  };

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <TransformationEdit
            transformationId={transformationId}
            onTransformationSaved={_onTransformationSaved}
          />
        </Col>
      </Row>
    </Container>
  );
}